import { Button, Card, CardContent, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import type { FirmwareUpstream } from "../../../types";

interface FirmwareUpstreamsCardProps {
  upstreams: FirmwareUpstream[];
  newUpstreamVendor: string;
  newUpstreamName: string;
  newUpstreamSourceUrl: string;
  setNewUpstreamVendor: (value: string) => void;
  setNewUpstreamName: (value: string) => void;
  setNewUpstreamSourceUrl: (value: string) => void;
  onCreateUpstream: () => void;
}

export function FirmwareUpstreamsCard({
  upstreams,
  newUpstreamVendor,
  newUpstreamName,
  newUpstreamSourceUrl,
  setNewUpstreamVendor,
  setNewUpstreamName,
  setNewUpstreamSourceUrl,
  onCreateUpstream,
}: FirmwareUpstreamsCardProps) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>Firmware Upstreams</Typography>
        <Stack direction={{ xs: "column", md: "row" }} spacing={1} sx={{ mb: 2 }}>
          <TextField
            label="Vendor"
            value={newUpstreamVendor}
            onChange={(e) => setNewUpstreamVendor(e.target.value)}
            fullWidth
          />
          <TextField
            label="Upstream Name"
            value={newUpstreamName}
            onChange={(e) => setNewUpstreamName(e.target.value)}
            fullWidth
          />
          <TextField
            label="Source URL (optional)"
            value={newUpstreamSourceUrl}
            onChange={(e) => setNewUpstreamSourceUrl(e.target.value)}
            fullWidth
          />
          <Button variant="contained" onClick={onCreateUpstream}>
            Add Upstream
          </Button>
        </Stack>
        {upstreams.length === 0 ? (
          <Typography variant="body2" color="text.secondary">No firmware upstreams configured.</Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Vendor</TableCell>
                <TableCell>Upstream</TableCell>
                <TableCell>Source URL</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {upstreams.map((upstream) => (
                <TableRow key={upstream.id}>
                  <TableCell>{upstream.vendor}</TableCell>
                  <TableCell>{upstream.name}</TableCell>
                  <TableCell>{upstream.source_url ?? "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
